import React from 'react';

import { ModalKeys } from '../../context/modals';
import { parameters, strings } from '../../localization/strings';
import ModalText from './text-modal';
import ExternalText from '../text/external-text';
import { useSite } from '../../hooks/use-site';
import TextPrivacyPolicy from '../text/self-co-privacy-policy';

export default function ModalPrivacyPolicy() {
  const { isSelfCo } = useSite();

  return (
    <ModalText type={ModalKeys.Privacy} title={strings()?.textPage?.privacyPolicy?.title || 'Privacy Policy'}>
      {parameters()?.textPage?.privacyPolicy}
      {isSelfCo ? <TextPrivacyPolicy /> : <ExternalText url={parameters()?.textPage?.privacyPolicy || ''} />}
    </ModalText>
  );
}
